// extracted by mini-css-extract-plugin
export default {"container":"mymessage_container__+dlyG","outerContainer":"mymessage_outerContainer__xXCWN","fileContainer":"mymessage_fileContainer__j01aU"};